export default __webpack_public_path__ + "static/media/SMA.d76067f5.jpg";